import DriverPositionUpdateModal from "./DriverPositionUpdateModal.vue";
import { ref } from "vue";

export interface BookingForMap {
    uuid: string;
    clientName?: string;
    origin_odometer?: number | null;
    destination_odometer?: number | null;
    actual_pick_up_time?: string | null;
    actual_drop_off_time?: string | null;
}

export interface DriverPositionUpdateModalParameters {
    journeyUuid?: string;
    bookingUuid?: string;
    booking?: BookingForMap;
    journeyBookings?: BookingForMap[];
    journeyOdometers?: {
        start_odometer?: number | null;
        end_odometer?: number | null;
    };
}

const DriverPositionUpdateModalPlugin = {
    install: (app: any) => {
        const driverPositionUpdates: any = {};
        const driverPositionUpdatesModalParameters = ref<DriverPositionUpdateModalParameters | null>(null);

        driverPositionUpdates.showForJourney = (journey: App.Models.Journey) => {
            const bookings: BookingForMap[] = (journey?.bookings ?? [])
                .map((b: App.Models.Booking) => ({
                    uuid: b.uuid,
                    clientName: b.client?.name ?? 'Unknown',
                    origin_odometer: b.origin_odometer ?? null,
                    destination_odometer: b.destination_odometer ?? null,
                    actual_pick_up_time:
                        b.events?.find((e: App.Models.BookingEvent) => e.type === 'pick_up')?.occurred_at ?? null,
                    actual_drop_off_time:
                        b.events?.find((e: App.Models.BookingEvent) => e.type === 'drop_off')?.occurred_at ?? null,
                }))
                .filter((b: BookingForMap) => b.actual_pick_up_time);

            driverPositionUpdatesModalParameters.value = {
                journeyUuid: journey?.uuid,
                journeyBookings: bookings,
                journeyOdometers: {
                    start_odometer: journey?.start_odometer ?? null,
                    end_odometer: journey?.end_odometer ?? null,
                },
            };
        };

        driverPositionUpdates.showForBooking = (booking: App.Models.Booking, journeyUuid?: string) => {
            driverPositionUpdatesModalParameters.value = {
                bookingUuid: booking?.uuid,
                journeyUuid,
                booking: {
                    uuid: booking?.uuid,
                    clientName: booking?.client?.name ?? undefined,
                    origin_odometer: booking?.origin_odometer ?? null,
                    destination_odometer: booking?.destination_odometer ?? null,
                    actual_pick_up_time:
                        booking?.events?.find((e: App.Models.BookingEvent) => e.type === 'pick_up')?.occurred_at ?? null,
                    actual_drop_off_time:
                        booking?.events?.find((e: App.Models.BookingEvent) => e.type === 'drop_off')?.occurred_at ?? null,
                },
            };
        };

        app.provide("driverPositionUpdatesModalParameters", driverPositionUpdatesModalParameters);
        app.provide("driverPositionUpdates", driverPositionUpdates);
        app.component("driver-position-update-modal", DriverPositionUpdateModal);
    },
};

export default DriverPositionUpdateModalPlugin;
